module.exports = __webpack_public_path__ + "static/media/food.42f6eefe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/food.jpeg
// module id = 195
// module chunks = 0